import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

/**
 * Ticket Master (#276) — header circle button that opens the Help-Desk ticket
 * research tool: type an invoice number → a unified, glanceable timeline of
 * what happened to that job (EventLog / Time Machine change stream, FileMaker
 * Schedule [DATA], FileMaker TurboQ) with a Claude-written conclusion.
 *
 * Visibility:
 *   - access-gated: the parent Header renders this only when
 *     canAccessTicketMaster passes (the "ticketMaster" token in
 *     tsUserDocument.screenAccessList — managed in UserDetailModal → Tab Access).
 *   - shown on every screen (like Compass, it's an operator tool, not tied to a
 *     schedulable concept — available regardless of whichList).
 *
 * Visual: matches the circular outline style of the "?" help icon, "🕒" Time
 * Machine, "🧭" Compass, and "📊" Dashboard, with a 🎫 ticket emoji centered.
 *
 * Click opens the tool via setOpenTicketMasterModal({ show: true }).
 */
const TicketMasterButton = () => {
  const { setOpenTicketMasterModal } = useContext(AppContext);

  const handleClick = () => {
    setOpenTicketMasterModal({ show: true });
  };

  return (
    <button
      onClick={handleClick}
      type="button"
      title="Ticket Master — Help Desk ticket research"
      aria-label="Open Ticket Master"
      className="w-7 h-7 ml-4 rounded-full border-2 border-skin-link text-skin-link font-bold leading-none flex items-center justify-center hover:opacity-75"
    >
      <span aria-hidden="true">{"\u{1F3AB}"}</span>
    </button>
  );
};

export default TicketMasterButton;
